var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-6", attrs: { fluid: "", "fill-height": "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex" },
        _vm._l(_vm.stockItems, function (stockItem, index) {
          return _c(
            "v-col",
            {
              key: `stockItem-${index}`,
              staticClass:
                "d-flex align-stretch col-sm-padding stock-item-card",
              attrs: {
                cols: "12",
                xs: "12",
                sm: "6",
                md: "4",
                lg: "3",
                xl: "2",
                "data-cy": `stock-item-card-${index}`,
              },
            },
            [
              _c("StockItemCard", {
                attrs: { stockItem: stockItem },
                on: {
                  add: _vm.add,
                  change: function ($event) {
                    return _vm.$emit("change", $event)
                  },
                },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }